/**
 * Adds thousands separator to the string (expected to be valid number format)
 *
 * @example
 * formatNumberWithThousandsSeparator(694_201_010.123456);
 * // Returns '694,201,010.123456'
 *
 */
const addThousandsSeparator = (valueProp: string | number): string => {
  const value = valueProp.toString();

  if (!Number(value)) return value;

  const [integerPart, decimalPart] = value.split('.');

  if (!integerPart) return value;

  const formattedIntegerPart = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ',',
  );

  return decimalPart
    ? `${formattedIntegerPart}.${decimalPart}`
    : formattedIntegerPart;
};

export default addThousandsSeparator;
